import React, { useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button, Form, Modal } from 'react-bootstrap';
import AppContext from 'context/Context';
import { post, patch } from 'services/bs-sector-measurable/sectorService';
import { search as searchKpi } from 'services/bs-kpi-board/kpiBoardService';
import { swalToastSuccess } from 'components/utilities/SwalToastUtil';
import BaseDropdownV2 from 'components/dropdowns/BaseDropdownV2';
import OptionListSelect from 'components/dropdowns/OptionListSelect';

const ScheduleTypeKey = 'balance.score.card.sectorscheduletype';
const SectorModal = ({ data, isShow, handleClose, handleSubmit, kpiId }) => {
  const {
    config: { isDark }
  } = useContext(AppContext);
  useEffect(() => {
    const dataJson = data && data.data ? JSON.parse(data.data) : {};
    const newData = {
      ...data,
      dataJson: dataJson
    };
    setFormData(newData);
  }, [data]);

  const [formData, setFormData] = useState(data);

  const handleChange = ({ target }) => {
    console.log(target);
    let name = target.name;
    let value = target.value;

    setFormData({ ...formData, [name]: value });
  };

  const handleDropdown = (field, value) => {
    console.log(field, value);
    const rq = { ...formData, [field]: value.id };
    if (field == 'scheduleType') {
      if (value?.name != 'Daily') {
        console.log('in');
        rq.isShowToday = false;
        rq.scheduleTypeText = '##';
      }
      else{
        rq.scheduleTypeText = 'Daily';
      }
    } else console.log(rq);
    setFormData({ ...rq });
  };

  const onSubmit = async e => {
    console.log('submit');
    e.preventDefault();

    const rq = { ...formData };

    if (rq.id > 0) {
      await patch(rq.id, { ...rq });
    } else {
      await post({ ...rq, kpiId: kpiId });
    }
    swalToastSuccess('Success');
    handleSubmit();
  };

  const onCheckboxChanges = e => {
    setFormData({ ...formData, isShowToday: e.target.checked });
  };
  return (
    <Modal show={isShow} onHide={handleClose} contentClassName="border">
      <Form onSubmit={onSubmit}>
        <Modal.Header
          closeButton
          closeVariant={isDark ? 'white' : undefined}
          className="bg-light px-card border-bottom-0"
        >
          <Modal.Title as="h5">
            {formData.id > 0 ? 'Edit' : 'Create'} Sector
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-card">
          <Form.Group className="mb-3" controlId="titleInput">
            <Form.Label className="fs-0 required">Name</Form.Label>
            <Form.Control
              type="text"
              name="name"
              required
              value={formData?.name}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="value2">
            <Form.Label className="fs-0 required">Order No</Form.Label>
            <Form.Control
              type="number"
              // name="value2"
              name="orderNo"
              required
              value={formData?.orderNo}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="scheduleType">
            <Form.Label className="fs-0 required">Schedule Type</Form.Label>
            <OptionListSelect
              optionKey={ScheduleTypeKey}
              selected={
                formData && formData.scheduleType ? formData.scheduleType : 0
              }
              changeFn={opt => handleDropdown('scheduleType', opt)}
            />
          </Form.Group>

          {formData?.kpiId > 0 && (
            <Form.Group className="mb-3" controlId="value2">
              <Form.Label className="fs-0 required">KPI</Form.Label>
              <BaseDropdownV2
                disabled={false}
                fieldName={'kpiId'}
                closeMenuOnSelect={true}
                isMulti={false}
                placeholder={'KPI'}
                handleChange={handleDropdown}
                getSource={searchKpi}
                sourceParam={{ isGetAll: true }}
                mapToOption={res => {
                  return res?.items.map(i => {
                    return { ...i, value: i.id, label: i.name };
                  });
                }}
                value={formData?.kpiId}
              />
            </Form.Group>
          )}
          {formData?.scheduleTypeText == 'Daily' && (
            <Form.Group className="mb-3">
              <Form.Label className="fs-0">Show Today</Form.Label>
              <Form.Check
                type="checkbox"
                checked={formData?.isShowToday}
                onChange={e => onCheckboxChanges(e)}
              />
            </Form.Group>
          )}
        </Modal.Body>
        <Modal.Footer className="bg-light px-card border-top-0">
          <Button
            variant="primary"
            type="submit"
            onClick={onsubmit}
            className="px-4 mx-0"
          >
            Save
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

SectorModal.propTypes = {
  measurables: PropTypes.array,
  data: PropTypes.object,
  isShow: PropTypes.bool,
  kpiId: PropTypes.number,
  handleClose: PropTypes.func,
  handleSubmit: PropTypes.func
};

export default SectorModal;
